module.exports = __webpack_public_path__ + "static/media/excell.0d891d9b.png";